import { IBlock, IDelayBlock } from 'common/builder/blocks/blockInterfaces'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import {
  FlowChartDelayBlock,
  FlowChartDelayType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartDelayBlock'
import { BlockType } from 'common/builder/constants/BlockType'

export const DelayBlockGenericConverterRule: ConverterRule<
  IDelayBlock,
  FlowChartDelayBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.DELAY,
  convert: (entity: IDelayBlock) => ({
    id: entity.id,
    type: FlowChartBlockType.DELAY,
    data: {
      delay: entity.time,
      delayType: entity.showTyping ? FlowChartDelayType.TYPING : FlowChartDelayType.WAITING,
    },
  }),
}
